import ContactInfoForm from './contact-info-form'

export default ContactInfoForm;